import script from "./viewCommentsAtom.vue?vue&type=script&setup=true&lang=ts"
export * from "./viewCommentsAtom.vue?vue&type=script&setup=true&lang=ts"

import "./viewCommentsAtom.vue?vue&type=style&index=0&id=14097b46&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14097b46"]])

export default __exports__